import { IStepProps } from './step/step.models';

// TODO: add to Core
export function canGoTo(stepDisabled: boolean, stepIndex: number, steps: IStepProps[]): boolean {
  if (stepDisabled) return false;

  const previousSteps = steps.slice(0, stepIndex);
  if (!previousSteps.length) return true;

  return previousSteps.every(previousStep => previousStep.completed || !previousStep.required);
}
